/**
 * Maps manual-assignment API rows to GenericFormsPage entities.
 */
export function mapManualAssignmentToEntity(item) {
  const manual = item.manual || {};
  const departments = manual.manualDepartments || [];
  const assignmentId = item.assignmentId ?? item.id;
  const status = item.status;

  return {
    id: assignmentId,
    assignmentId,
    viewStatus: status,
    viewStatusLabel: status === 'VIEWED' ? 'Viewed' : 'Pending',
    canView: item.canView !== false,
    unavailableReason: item.unavailableReason,
    assignedAt: item.assignedAt,
    viewedAt: item.viewedAt,
    manualId: manual.id,
    code: manual.code,
    title: manual.title,
    description: manual.description,
    manualStatus: manual.status,
    manualStatusLabel: manual.statusLabel,
    manualTypeName: manual.manualTypeName || manual.manualType?.typeName || null,
    manualDepartments: departments,
    departmentLabels: departments.map((d) => d.name).join(', '),
    fileAttachments: [],
    fileAttachmentCount: 0,
  };
}

export function mapManualAssignmentFromApi(dto) {
  return mapManualAssignmentToEntity(dto);
}
